import React from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { FormGroup, Label, FormFeedback } from "reactstrap";
import { translator } from '../../utils/Translator';

const SelectInput = ({
  label,
  value,
  onChange,
  options,
  error,
  placeholder,
  isDisabled = false,
  isSearchable = true,
  isMulti = false,
  isClearable = true,
  isLabelBold = false,
  isLoading = false,
  getOptionLabel,
  getOptionValue,
  menuPosition,
}) => {
  const { translate } = useSelector(({ i18n }) => i18n);
  
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  // custom styles ของ react-select
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: error
        ? "red"
        : state.isFocused
        ? "#FF5722" // สีส้มเวลา focus
        : provided.borderColor,
      boxShadow: state.isFocused ? "0 0 0 1px #FF5722" : provided.boxShadow,
      "&:hover": {
        borderColor: state.isFocused ? "#FF5722" : provided.borderColor,
      },
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999, // เพิ่ม z-index ให้สูงขึ้นสำหรับ menuPortal
    }),
  };

  const defaultPlaceholder = placeholder || translator(translate?.ISA_Choose, "-- Select --");

  return (
    <FormGroup style={{ marginBottom: 0 }}>
      {label && (
        <Label style={{ fontWeight: isLabelBold ? "bold" : "normal" }}>
          {label}
        </Label>
      )}
      <Select
        value={value}
        onChange={handleChange}
        options={options}
        placeholder={defaultPlaceholder}
        className={error ? "is-invalid" : ""}
        menuPortalTarget={document.body}
        menuPosition={menuPosition}
        styles={customStyles}
        isDisabled={isDisabled}
        isSearchable={isSearchable}
        isMulti={isMulti}
        isClearable={isClearable}
        isLoading={isLoading}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
      />
      {error && <FormFeedback style={{ display: "block" }}>{error}</FormFeedback>}
    </FormGroup>
  );
};

export default SelectInput;